import { AxiosInstance } from 'axios';
import {
  CancelExportReportRequest,
  CancelExportReportResponse,
  ExportReportEndpoints,
  GetExportDetailsRequest,
  GetExportDetailsResponse,
  SearchExportReportsRequest,
  SearchExportReportsResponse,
  StartExportRequest,
  StartExportResponse,
} from './ExportReportServices.types';

export class ExportReportServices implements ExportReportEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  start(request: StartExportRequest) {
    return this.instance.post<StartExportResponse>(
      `/reports/${request.routeParams.reportId}/exports`,
      request.body,
    );
  }

  getById(request: GetExportDetailsRequest) {
    return this.instance.get<GetExportDetailsResponse>(
      `/reports/${request.routeParams.reportId}/exports/${request.routeParams.exportId}`,
    );
  }

  search(request: SearchExportReportsRequest) {
    return this.instance.get<SearchExportReportsResponse>(
      `/reports/${request.routeParams.reportId}/exports`,
      {
        params: request.queryParams,
      },
    );
  }

  cancel(request: CancelExportReportRequest) {
    return this.instance.delete<CancelExportReportResponse>(
      `/reports/${request.routeParams.reportId}/exports/${request.routeParams.exportId}`,
    );
  }
}
